<template>
	<div>

		<span style="color:red;">{{message}}</span>
		<!--
		<div class="inputItemDiv"><div class="inputTitleDiv">旧パスワード</div><input class="input" type="password" v-model="oldPassword"></div>
		<div class="inputItemDiv" v-show="!resOldPasswordVal"><div class="inputErrorTitleDiv"></div><span class="validateError">入力必須。10文字以内で入力して下さい。</span></div>
		-->
		
		<div class="inputItemDiv"><div class="inputTitleDiv">新パスワード</div><input class="input" type="password" v-model="newPassword1"></div>
		<div class="inputItemDiv" v-show="!resNewPassword1Val"><div class="inputErrorTitleDiv"></div><span class="validateError">入力必須。10文字以内で入力して下さい。</span></div>
		
		<div class="inputItemDiv"><div class="inputTitleDiv">新パスワード(再)</div><input class="input" type="password" v-model="newPassword2"></div>
		<div class="inputItemDiv" v-show="!resNewPassword2Val"><div class="inputErrorTitleDiv"></div><span class="validateError">入力必須。10文字以内で入力して下さい。</span></div>

		<div class="inputItemDiv" v-show="!resNewPasswordMatchVal"><span class="validateError">新パスワードが一致していません。</span></div>
		<br>
		<div class="inputItemDiv" style="text-align:right">
			<button  type="button" class="button" @click='cancel'>ｷｬﾝｾﾙ</button>
			<button :disabled="resAllVal"  type="button" class="button" @click='change'>変更</button>
		</div>

	</div>

</template>

<script>

import {ref} from 'vue';

import passwordChangeValidator from '../composables/PasswordChangeValidator'
import accountRepository from '../composables/AccountRepository'

export default ({
  name: 'PasswordChange',

  setup(props, context){
 
    const message = ref("　")
    const oldPassword = ref("aaaa")
    const newPassword1 = ref("")
    const newPassword2 = ref("")
    
    const { changePassword } = accountRepository()
   
    
    const change = () =>{
      changePassword( oldPassword.value, newPassword1.value, callback)
    }
    
    const callback = ( result) => {
      if( result == "success"){
        message.value = "変更完了"
        context.emit( 'setIsEdit', false )
      }else if( result == "error"){
        message.value = "古いパスワードが間違っています。"
      }else{
        message.value = result
      }
    }
    
    const cancel = () =>{
      context.emit( 'setIsEdit', false )
    }
    
    const { 
      resOldPasswordVal,
      resNewPassword1Val,
      resNewPassword2Val,
      resNewPasswordMatchVal,
      resAllVal } = passwordChangeValidator( oldPassword, newPassword1, newPassword2 )
    
    //template上で使用する変数を宣言
    return{
      message,
      oldPassword,
      newPassword1,
      newPassword2,
      cancel,
      resOldPasswordVal,
      resNewPassword1Val,
      resNewPassword2Val,
      resNewPasswordMatchVal,
      resAllVal,
      change
    }
  }

})

</script>


